export enum Endpoints {
  ANALYTICS_API_BASE = 'https://analytics.ipe.wiki/api/v6',
  ANALYTICS_DASH_URL = 'https://analytics.ipe.wiki',
  GITHUB_URL = 'https://github.com/inpageedit/inpageedit-next',
  GITHUB_OWNER = 'inpageedit',
  GITHUB_REPO = 'inpageedit-next',
  HOME_URL = 'https://www.ipe.wiki/',
  UPDATE_LOGS_URL = 'https://www.ipe.wiki/changelogs/',
  PLUGIN_REGISTRY_URL = 'https://registry.ipe.wiki/registry.v1.json',
  I18N_INDEX_URL = 'https://registry.ipe.wiki/i18n/index.json',
  QQ_GROUP_ID = '1026023666',
}
